import React from 'react';
import { motion } from 'framer-motion';

const TechStaffingServices = ({ title, description, features = [] }) => {
  return (
    <section
      className="py-24 px-6 relative overflow-hidden"
      style={{ backgroundColor: '#ffffff', color: '#001534' }}
    >
      <div className="max-w-[1240px] mx-auto">
        {/* Header */}
        <motion.div
          className="text-center mb-14"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-2xl md:text-4xl font-bold leading-tight mb-5">
            {title}
          </h2>
          <p className="text-base max-w-2xl mx-auto leading-relaxed text-center" style={{ color: '#475569' }}>
            {description}
          </p>
        </motion.div>

        {/* Bento Matrix Grid */}
        <div
          className="grid grid-cols-1 md:grid-cols-2 mt-10"
          style={{ borderTop: '1px solid rgba(0, 21, 52, 0.06)', borderLeft: '1px solid rgba(0, 21, 52, 0.06)' }}
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="p-10 md:p-12 relative overflow-hidden transition-all duration-300 group"
              style={{
                borderRight: '1px solid rgba(0, 21, 52, 0.06)',
                borderBottom: '1px solid rgba(0, 21, 52, 0.06)',
              }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(0, 114, 255, 0.02)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
            >
              <div
                className="text-3xl mb-6 inline-block transition-transform duration-300 group-hover:scale-110 group-hover:-translate-y-0.5"
                style={{ color: '#0072ff' }}
              >
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-3.5" style={{ color: '#001534' }}>
                {feature.title}
              </h3>
              <p className="text-md leading-relaxed text-left m-0" style={{ color: '#475569', wordBreak: 'normal', overflowWrap: 'normal', hyphens: 'none', whiteSpace: 'normal' }}>
                {feature.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStaffingServices;
